'use strict'

// service we have section 
const ul = document.getElementById("mainList");
const liList = ul.querySelectorAll("li");
const imageList = document.querySelectorAll(".hiddenImage");
ul.addEventListener("click", (event) => {
    const { id } = event.target;
    liList.forEach((e) => {
    if (e.id === id) {
        e.classList?.add("underlines");
    } else {
        e.classList?.remove("underlines");
    }
    });

    const sectionId = id.split("_")[1];
    imageList.forEach((e) => {
    if (e.id === sectionId) {
        e.classList?.add("visibleImage");
    } else {
        e.classList?.remove("visibleImage");
    }
    });
});


















// counter
const counters = document.querySelectorAll('.counter');
const speed = 200; // The lower the slower

counters.forEach(counter => {
    const updateCount = () => {
        const target = +counter.getAttribute('data-target');
        const count = +counter.innerText;

        // Lower inc to slow and higher to slow
        const inc = target / speed;
        // Check if target is reached
        if (count < target) {
            // Add inc to count and output in counter
            counter.innerText = count + inc;
            // Call function every ms
            setTimeout(updateCount, 1);
        } else {
            counter.innerText = target;
        }
    };

    updateCount();
});

